import React, { useContext, useEffect, useRef, useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import type { InputRef } from 'antd'
import { Space, Input, Tag, Tooltip, theme } from 'antd'
import SegmentContext from '../SegmentHelpers/hooks/createContext'

export interface ITapProps {
  tagIndex: number
  name: string
}

const TagTrigger: React.FC<ITapProps> = (props) => {
  const {
    stickers: [stickers, setStickers],
    isChanging: [_isChanging, setIsChanging]
  } = useContext(SegmentContext)!
  const { tagIndex, name } = props
  const { token } = theme.useToken()
  let tags = name == null ? [] : [name]
  // const [tags, setTags] = useState<string[]>(name == null ? [] : [name])
  // const [tags, setTags] = useState<string[]>([])
  const [inputVisible, setInputVisible] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [editInputIndex, setEditInputIndex] = useState(-1)
  const [editInputValue, setEditInputValue] = useState('')
  const inputRef = useRef<InputRef>(null)
  const editInputRef = useRef<InputRef>(null)

  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus()
    }
  }, [inputVisible])

  useEffect(() => {
    editInputRef.current?.focus()
  }, [inputValue])

  const handleClose = (removedTag: string) => {
    const newTags = tags.filter((tag) => tag !== removedTag)
    console.log(newTags)
    tags = newTags
    // setTags(newTags)
    stickers[tagIndex].name = null
    setStickers([...stickers])
  }

  const showInput = () => {
    setInputVisible(true)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
  }

  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      // setTags([...tags, inputValue])
      tags = [...tags, inputValue]
    }
    setInputVisible(false)
    setInputValue('')
    stickers[tagIndex].name = inputValue
    setStickers([...stickers])
    setIsChanging(true)
  }

  const handleEditInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditInputValue(e.target.value)
  }

  const handleEditInputConfirm = () => {
    const newTags = [...tags]
    newTags[editInputIndex] = editInputValue
    // setTags(newTags)
    tags = newTags
    setEditInputIndex(-1)
    setInputValue('')
    stickers[tagIndex].name = editInputValue
    // console.log(tagIndex)
    setStickers([...stickers])
    setIsChanging(true)
  }

  const tagInputStyle: React.CSSProperties = {
    width: 78,
    verticalAlign: 'top'
  }

  const tagPlusStyle: React.CSSProperties = {
    background: token.colorBgContainer,
    borderStyle: 'dashed'
  }

  return (
    <Space size={[0, 8]} wrap>
      <Space size={[0, 8]} wrap>
        {tags.map((tag, index) => {
          if (editInputIndex === index) {
            return (
              <Input
                ref={editInputRef}
                key={tag}
                size='small'
                style={tagInputStyle}
                value={editInputValue}
                onChange={handleEditInputChange}
                onBlur={handleEditInputConfirm}
                onPressEnter={handleEditInputConfirm}
              />
            )
          }
          const isLongTag = tag.length > 20
          const tagElem = (
            <Tag
              key={tag}
              closable={true}
              style={{ userSelect: 'none' }}
              onClose={() => handleClose(tag)}
            >
              <span
                onDoubleClick={(e) => {
                  setEditInputIndex(index)
                  setEditInputValue(tag)
                  e.preventDefault()
                }}
              >
                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
              </span>
            </Tag>
          )
          return isLongTag ? (
            <Tooltip title={tag} key={tag}>
              {tagElem}
            </Tooltip>
          ) : (
            tagElem
          )
        })}
      </Space>
      {inputVisible ? (
        <Input
          ref={inputRef}
          type='text'
          size='small'
          style={tagInputStyle}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      ) : tags.length === 0 ? (
        <Tag style={tagPlusStyle} onClick={showInput}>
          <PlusOutlined /> 新标签
        </Tag>
      ) : (
        <></>
      )}
    </Space>
  )
}

export default TagTrigger
